import React from 'react'

// Shows "?" face-down until the room is revealed, then flips (3D rotateY)
// to show the actual vote. Before reveal, a voted card gets a highlighted
// border so the master can see who's ready without seeing what they picked.
const PokerTableCard = ({ voted, revealed, vote }) => {
  let label = 'ainda não votou'
  if (revealed) label = `votou ${vote ?? 'nada'}`
  else if (voted) label = 'já votou, carta virada pra baixo'

  return (
    <span
      className={`poker-table-card${revealed ? ' revealed' : ''}${voted && !revealed ? ' voted' : ''}`}
      role="img"
      aria-label={label}
    >
      <span className="poker-table-card-inner">
        <span className="poker-table-card-face poker-table-card-back">?</span>
        <span className="poker-table-card-face poker-table-card-front">{vote ?? '—'}</span>
      </span>
    </span>
  )
}

export default PokerTableCard
